export default "__VITE_ASSET__ggaRSbbC__"